/**
 * Нет авторизованного пользователя — записать данные регламента некому.
 */
export class WorkflowStorageOwnerMissingError extends Error {
  constructor() {
    super('Workflow storage owner is not available');
    this.name = 'WorkflowStorageOwnerMissingError';
  }
}
